import {
  PaymentMethodMicroFrontend,
  PaymentsMethodMfeExposedApi,
} from '@ftdr/payment-method-v2-micro-frontend';
import * as React from 'react';
import { useRef, useEffect, useMemo, useState } from 'react';
import { getJWT } from '@app/auth/authService';
import { getConfig } from '@services/app.config.loader';
// eslint-disable-next-line camelcase
import { payment3_commonpb, payment3_paymentmethodpb } from '@ftdr/payment3_paymentmethod_coordinator-js-client';
import { fireGAEvent } from '@app/core/tracking.service';
import { ORDER__MAKE_PAYMENT } from '@constants/ga-events.constants';
import { PAYMENTS } from '@constants/newOrder-constants';
import { getBrand } from '@helpers/brand.utils';

const mapBrandToPaymentProtobuf = new Map([
  ["AHS", payment3_commonpb.Brand.AHS],
  ["HSA", payment3_commonpb.Brand.HSA],
  ["HBW210", payment3_commonpb.Brand.HBW210],
]);

interface Props {
  handleMFEResponse: any;
  contractId: any;
  isSubmitting: boolean;
}

const StripeMFE: React.FC<Props> = (props: Props) => {
  const submitFunctionRef = useRef<PaymentsMethodMfeExposedApi>(null);

  const [activePaymentMethod, setActivePaymentMethod] = useState('');
  const [jwtToken, setJwtToken] = useState(getJWT());
  const [agregatePaymentResponse, setAgregatePaymentResponse] = useState({});

  const brand = getBrand();

  const brandPb = useMemo(() => {
    const mappedBrand = mapBrandToPaymentProtobuf.get(brand);
    if (!mappedBrand || mappedBrand === payment3_commonpb.Brand.Unknown) {
      console.error(`Invalid or unknown brand: ${brand}, falling back to AHS`);
      return payment3_commonpb.Brand.AHS;
    }
    return mappedBrand;
  }, [brand]);

  const submitToMFE = async () => {
    console.log('Waiting for result');
    if (activePaymentMethod === 'CREDIT_CARD') {
      const creditCardResult = await submitFunctionRef.current!.processPayment({
        stripe: {
          owner: {
            ownerIdentity: {
              type: payment3_paymentmethodpb.OwnerIdentityType.ContractIdentityType,
              contractIdentity: {
                contractID: props.contractId,
              },
            },
          },
        },
      });
      setAgregatePaymentResponse(creditCardResult);
      console.log('CC Result', creditCardResult);
      fireGAEvent(ORDER__MAKE_PAYMENT(PAYMENTS.CC, props.contractId));
      props.handleMFEResponse(creditCardResult.stripe);
    } else if (activePaymentMethod === 'BANK_ACCOUNT') {
      const paymentusResult = await submitFunctionRef.current!.processPayment({
        paymentus: {
          owner: {
            name: 'SVCRealEstatePro',
            ownerIdentity: {
              type: payment3_paymentmethodpb.OwnerIdentityType.ContractIdentityType,
              contractIdentity: {
                contractID: props.contractId,
              },
            },
          },
          source: {
            name: 'SVCRealEstatePro',
          },
        },
      });
      setAgregatePaymentResponse(paymentusResult);
      console.log('paymentus result', paymentusResult);
      fireGAEvent(ORDER__MAKE_PAYMENT(PAYMENTS.ACH, props.contractId));
      props.handleMFEResponse(paymentusResult.paymentus);
    } else {
      // should never hit this
      const achResult = await submitFunctionRef.current!.processPayment({});
      setAgregatePaymentResponse(achResult);
      console.log('ACH Result', achResult);
    }
  };

  useEffect(() => {
    if (props.isSubmitting) {
      submitToMFE();
    }
  }, [props.isSubmitting]);

  return (
    <>
      <PaymentMethodMicroFrontend
        applicationName="SVCRealEstatePro"
        brand={brandPb}
        owner={{
          ownerIdentity: {
            type: payment3_paymentmethodpb.OwnerIdentityType.ContractIdentityType,
            contractIdentity: { contractID: props.contractId },
          },
        }}
        availablePaymentMethods={{
          BANK_ACCOUNT: true,
          CREDIT_CARD: true,
          PAYPAL: false,
        }}
        defaultOpenPaymentMethod="BANK_ACCOUNT"
        token={jwtToken}
        baseURL={`${getConfig('baseApiUrl')}/`}
        ref={submitFunctionRef}
        paymentusIframeBaseUrl={getConfig('paymentusUrl')}
        achPaymentProcessor={'achpaymentus'}
        cardPaymentProcessor="stripe"
        onStateChange={(state) => {
          if (state?.activePaymentMethod !== activePaymentMethod && state?.activePaymentMethod) {
            setActivePaymentMethod(state?.activePaymentMethod);
          }
        }}
        onSuccess={() => {}}
        onFailure={() => {}}
        onResponse={(e) => {
          if (e?.setupCardSuccessResponse) {
            console.log('setupCardSuccessResponse');
          }
          if (e?.stripeSuccessResponse) {
            console.log('stripeSuccessResponse');
          }
          if (e?.registrationSuccessResponse) {
            console.log('registrationSuccessResponse');
          }
        }}
      />
    </>
  );
};

export default StripeMFE;
